/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listReposByCollection.defs.js'
export { main as default } from './listReposByCollection.defs.js'
